export class CustomReportsTextCopy {

  public static team = `team(s)`;
  public static pcnNumber = `PCN number`;
  public static user = `user(s)`;
  public static contravention = 'contranvention number(s)';
  public static startDate = 'start of date range (for letters created in Response Master)';
  public static stage = 'stage(s)';
  public static endDate = 'end of date range (for letters created in Response Master)';
  public static bespoke = "letter(s) done using the 'bespoke' button";
  public static pcnType = `PCN type`;
  public static decision = `decision(s) given to drivers`;
  public static pcnPrefix = `PCN prefix(es)`;
  public static provokedUfu = `provoked an unwanted follow-up (UFU) letter`;
  public static override = `letter(s) where the user has changed (overridden) the RM decision`;
  public static reason = `reason(s) selected by user(s)`;
  public static location = `location`;

  public static reportUser = `click to sort by user`;
  public static reportDate = `click to sort by date`;
  public static reportPcn = `click to sort by PCN number`;
  public static reportStage = `click to sort by stage`;
  public static reportDecision = `click to sort by decision`;
  public static reportCharge = `click to sort by charge`;
  public static reportProgression = `click to sort by progression code`;
  public static reportBespoke = `bespoke letter? Click to sort by this`;
  public static reportOverride = `RM decision changed (overridden)? Click to sort by this`;
  public static reportUfu = `provoked an unwanted follow-up (UFU) letter? Click to sort by this`;

}
